module.exports = __webpack_public_path__ + "img/jcyj_index6.18772ec9.jpg";